import { all } from 'redux-saga/effects'
import userSagas from './userAccountSagas';
import enterpriseSagas from './enterpriseSagas';
import emailEnterpriseMapSagas from './emailEnterpriseMapSagas';

export default function* rootSaga(dispatch) {
  yield all([
    ...userSagas,
    ...enterpriseSagas,
    ...emailEnterpriseMapSagas
  ])
}


// WEBPACK FOOTER //
// ./src/sagas/index.js